import React, { useEffect, useState } from "react";
import { format } from "date-fns";
import { useSelector, useDispatch } from "react-redux";
import { getOrders, getCustomerNumber } from "store/reducers";
import { getOrderHistory } from "store/actions";
import Paper from "components/generic/Paper/Paper";
import Table from "components/generic/Table/Table/Table";
import TablePagination from "components/generic/Table/TablePagination/TablePagination";
import TableCell from "components/generic/Table/TableCell/TableCell";
import TableRow from "@material-ui/core/TableRow";
import MaterialButton from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import { cMSResources } from "../../../index";

import "./PastOrders.scss";

function findArrayElementByTitle(array, key) {
  return array.find((element) => {
    return element.key === key;
  });
}

const rowsPerPage = 25;

const PastOrders = () => {
  const orders = useSelector(getOrders);
  const customerNumber = useSelector(getCustomerNumber);
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
  const [expandedRows, setExpandedRows] = useState({});

  const handleChangeRowsPerPage = () => {
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 600);
  };

  const toggleRowExpansion = (orderNumber) => {
    setExpandedRows((prev) => ({
      ...prev,
      [orderNumber]: !prev[orderNumber],
    }));
  };

  useEffect(() => {
    dispatch(getOrderHistory(customerNumber));

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [dispatch, customerNumber]);

  const pagedResult =
    orders &&
    orders.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  var cmsOrderNumber = findArrayElementByTitle(cMSResources, "{{OrderNumber}}");
  var cmsOrderDate = findArrayElementByTitle(cMSResources, "{{OrderDate}}");
  var cmsOrderTotal = findArrayElementByTitle(cMSResources, "{{OrderTotal}}");
  var cmsWebOrders = findArrayElementByTitle(cMSResources, "{{WebOrders}}");
  var cmsOrderShippingDate = findArrayElementByTitle(
    cMSResources,
    "{{OrderShippingDate}}"
  );
  var cmsDetails = findArrayElementByTitle(cMSResources, "{{Details}}");
  var cmsItemNumber = findArrayElementByTitle(
    cMSResources,
    "{{ItemNumber}}"
  ) || { value: "Item Number" };
  var cmsItemName = findArrayElementByTitle(cMSResources, "{{ItemName}}") || {
    value: "Item Name",
  };
  var cmsQuantity = findArrayElementByTitle(cMSResources, "{{Quantity}}") || {
    value: "Quantity",
  };
  var cmsUnitPrice = findArrayElementByTitle(cMSResources, "{{UnitPrice}}") || {
    value: "Unit Price",
  };

  const formatCurrency = (amount, currencyCode) => {
    if (currencyCode === "USD") {
      return `$${amount}`;
    } else {
      return `${currencyCode} ${amount}`;
    }
  };

  // Render order details when row is expanded
  const renderOrderDetails = (order) => {
    if (
      !order.customerPortalOrderHistoryDetail ||
      order.customerPortalOrderHistoryDetail.length === 0
    ) {
      return <div className="no-details">No detail information available</div>;
    }

    return (
      <div className="order-details">
        <Table
          head={
            <>
              <TableCell>{cmsItemNumber.value}</TableCell>
              <TableCell>{cmsItemName.value}</TableCell>
              <TableCell align="center">{cmsQuantity.value}</TableCell>
              <TableCell align="right">{cmsUnitPrice.value}</TableCell>
              <TableCell align="right">{cmsOrderTotal.value}</TableCell>
            </>
          }
        >
          {order.customerPortalOrderHistoryDetail.map((item, idx) => (
            <TableRow key={`detail-${order.orderNumber}-${idx}`}>
              <TableCell>{item.itemNumber}</TableCell>
              <TableCell>{item.itemName}</TableCell>
              <TableCell align="center">{item.orderQuantity}</TableCell>
              <TableCell align="right">
                {formatCurrency(
                  item.averageUnitPriceLocal,
                  item.localCurrencyCode
                )}
              </TableCell>
              <TableCell align="right">
                {formatCurrency(
                  item.netOrderAmountLocalCurrency,
                  item.localCurrencyCode
                )}
              </TableCell>
            </TableRow>
          ))}
        </Table>
      </div>
    );
  };

  return (
    <>
      <div className="past-orders-container">
        {isMobile ? (
          <div className="mobile-orders">
            {pagedResult &&
              pagedResult.map((row, index) => (
                <div key={`mobile-row-${index}`} className="mobile-order">
                  <div className="mobile-order-header">
                    <div>
                      {cmsOrderNumber.value}: {row.orderNumber}
                    </div>
                    {row.customerPortalOrderHistoryDetail &&
                      row.customerPortalOrderHistoryDetail.length > 0 && (
                        <IconButton
                          size="small"
                          onClick={() => toggleRowExpansion(row.orderNumber)}
                          className={`expand-icon ${
                            expandedRows[row.orderNumber] ? "expanded" : ""
                          }`}
                        >
                          <ExpandMoreIcon />
                        </IconButton>
                      )}
                  </div>
                  <div>
                    {cmsOrderDate.value}:{" "}
                    {format(new Date(row.orderDate), "MM/dd/yyyy")}
                  </div>
                  <div>
                    {cmsOrderTotal.value}:{" "}
                    {formatCurrency(
                      row.netOrderAmountLocalCurrency,
                      row.localCurrencyCode
                    )}
                  </div>
                  <div>
                    {cmsWebOrders.value}: {row.isWebOrder ? "Yes" : "No"}
                  </div>
                  <div>
                    {cmsOrderShippingDate.value}: {row.shipDate}
                  </div>
                  {/* <div>
                    <MaterialButton
                      variant="contained"
                      color="primary"
                      href={`/orderHistoryDetails/?oNo=${row.orderNumber}`}
                    >
                      {cmsDetails.value}
                    </MaterialButton>
                  </div> */}
                  <Collapse
                    in={expandedRows[row.orderNumber]}
                    timeout="auto"
                    unmountOnExit
                  >
                    <div className="mobile-order-details">
                      {renderOrderDetails(row)}
                    </div>
                  </Collapse>
                </div>
              ))}
          </div>
        ) : (
          <Paper variant="gray" className="past-orders-paper">
            <Table
              head={
                <>
                  <TableCell width="40px"></TableCell>
                  <TableCell align="left">{cmsOrderNumber.value}</TableCell>
                  <TableCell>{cmsOrderDate.value}</TableCell>
                  <TableCell className="past-orders-order-total" align="center">
                    {cmsOrderTotal.value}
                  </TableCell>
                  <TableCell align="center">{cmsWebOrders.value}</TableCell>
                  <TableCell>{cmsOrderShippingDate.value}</TableCell>
                  {/* <TableCell>{cmsDetails.value}</TableCell> */}
                </>
              }
            >
              {pagedResult &&
                pagedResult.map((row, index) => (
                  <React.Fragment key={`desktop-row-${index}`}>
                    <TableRow className="generic-table-body-row">
                      <TableCell>
                        {row.customerPortalOrderHistoryDetail &&
                        row.customerPortalOrderHistoryDetail.length > 0 ? (
                          <IconButton
                            size="small"
                            onClick={() => toggleRowExpansion(row.orderNumber)}
                            className={`expand-icon ${
                              expandedRows[row.orderNumber] ? "expanded" : ""
                            }`}
                          >
                            <ExpandMoreIcon />
                          </IconButton>
                        ) : null}
                      </TableCell>
                      <TableCell>{row.orderNumber}</TableCell>
                      <TableCell>
                        {format(new Date(row.orderDate), "MM/dd/yyyy")}
                      </TableCell>
                      <TableCell
                        className="past-orders-order-total"
                        align="center"
                      >
                        {formatCurrency(
                          row.netOrderAmountLocalCurrency,
                          row.localCurrencyCode
                        )}
                      </TableCell>
                      <TableCell align="center">
                        {row.isWebOrder ? "Yes" : "No"}
                      </TableCell>
                      <TableCell>{row.shipDate}</TableCell>
                    </TableRow>
                    {row.customerPortalOrderHistoryDetail &&
                      row.customerPortalOrderHistoryDetail.length > 0 && (
                        <TableRow
                          className={`detail-row ${
                            expandedRows[row.orderNumber] ? "expanded" : ""
                          }`}
                        >
                          <TableCell colSpan={6} className="detail-cell">
                            {expandedRows[row.orderNumber] && (
                              <div className="order-details-wrapper">
                                {renderOrderDetails(row)}
                              </div>
                            )}
                          </TableCell>
                        </TableRow>
                      )}
                  </React.Fragment>
                ))}
            </Table>
          </Paper>
        )}
      </div>

      {pagedResult && (
        <TablePagination
          count={orders.length}
          rowsPerPage={rowsPerPage}
          page={page}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      )}
    </>
  );
};

export default PastOrders;
